import { msalInstance } from "./msalInstance";

export async function getPowerBIToken(email) {
  const scopes = ["https://analysis.windows.net/powerbi/api/.default"];

  await msalInstance.initialize();

  let account = undefined;

  // First try MSAL. This is the case we should hit once we have gone through the token flow once
  // for this session and are rendering another report.
  if (email) {
    account = msalInstance
      .getAllAccounts()
      .find((acc) => acc.username.toLowerCase() === email.toLowerCase());

    console.log("getPowerBIToken | account from MSAL: ", account); // CRTODO: Remove once done testing
  }

  // Fallback option to avoid prompting the user with an account selection dialog on the first report
  // access per session. By storing the account (not sensitive) in local storage, we can read it
  // and try to use it in the token acquisition step.
  if (!account) {
    const cachedAccountJson = localStorage.getItem("edss-powerbi-account");
    if (cachedAccountJson) {
      const cachedAccount = JSON.parse(cachedAccountJson);
      if (cachedAccount?.username?.toLowerCase() === email.toLowerCase()) {
        console.log(
          "getPowerBIToken | account from local storage: ",
          cachedAccount,
        );
        account = cachedAccount;
      } else {
        // Found something in local storage that doesn't match the logged-in user. Remove it.
        localStorage.removeItem("edss-powerbi-account");
      }
    }
  }

  // First, see if MSAL already has a logged in account for the specified domain. If so we
  // should be able to make a simple silent token request.
  if (account) {
    console.log("getPowerBIToken | acquireTokenSilent"); // CRTODO: Remove once done testing
    try {
      const acquireResult = await msalInstance.acquireTokenSilent({
        scopes,
        account,
      });

      const acquireTokenSilentToken = acquireResult.accessToken;
      console.log(
        "getPowerBIToken | acquireTokenSilent token: ",
        acquireTokenSilentToken ? "YES" : "NO",
      ); // CRTODO: Remove once done testing

      if (account) {
        localStorage.setItem("edss-powerbi-account", JSON.stringify(account));
      }

      return acquireTokenSilentToken;
    } catch (err) {
      console.warn("getPowerBIToken | acquireTokenSilent failed: ", err);
    }
  }

  // Second, if we don't have a MSAL account in hand, we can use the ssoSilent approach
  // where a hidden iframe is used to (hopefully) log us in without a prompt based on
  // an existing AAD login site token in the browser.
  console.log("getPowerBIToken | ssoSilent hint: ", email); // CRTODO: Remove once done testing
  try {
    const ssoSilentResult = await msalInstance.ssoSilent({
      scopes,
      loginHint: email, // THIS LINE CHANGED BY KUNLE
    });

    const ssoSilentToken = ssoSilentResult.accessToken;
    console.log(
      "getPowerBIToken | ssoSilent token: ",
      ssoSilentToken ? "YES" : "NO",
    ); // CRTODO: Remove once done testing

    return ssoSilentToken;
  } catch (err) {
    console.warn("getPowerBIToken | ssoSilent failed: ", err);
  }

  // Third, fall back to an interactive flow
  // CRTODO: Popup vs redirect
  console.log("getPowerBIToken | acquireTokenPopup");
  try {
    const popupResult = await msalInstance.acquireTokenPopup({
      scopes,
      loginHint: email, //THIS LINE CHANGED BY KUNLE
      prompt: "select_account",
    });

    const popupToken = popupResult.accessToken;
    console.log(
      "getPowerBIToken | acquireTokenPopup token: ",
      popupToken ? "YES" : "NO",
    ); // CRTODO: Remove once done testing

    const popupAccount = popupResult.account;
    if (popupAccount) {
      localStorage.setItem(
        "edss-powerbi-account",
        JSON.stringify(popupAccount),
      );
    }

    return popupToken;
  } catch (err) {
    console.warn("getPowerBIToken | acquireTokenPopup failed: ", err);
    localStorage.removeItem("edss-powerbi-account");
  }
}
